import axios from "axios";
import dayjs from "dayjs";
import { isLocalhost } from "../Utils/utils";

const urlApi = isLocalhost ? "/api" : process.env.REACT_APP_API;
const localAgentUrl = process.env.REACT_APP_LOCAL_AGENT;

export const logIn = dados => ({ type: "LOGIN", dados });

export const logOut = () => ({ type: "LOGOUT" });

export const setLoged = loged => ({ type: "SETLOGED", loged });

export const setDados = dados => ({ type: "SETDADOS", dados });

export const setDadosPesq = (name, dados) => ({ type: "SETDADOSPESQ", name, dados });

export const resetAllDadosPesq = () => ({ type: "RESETDADOSALL" });

export const resetDadoPesq = nome => ({ type: "RESETDADOPESQ", nome });

export const cadastrarGrupo = dados => ({ type: "CADASTRAR", dados });

export const setCadastrado = (isCadastrado, acessoRevogado, ambiente, alertas) => ({ type: "SETCADASTRO", dados: { isCadastrado, acessoRevogado, ambiente, alertas } });

export const setCaixa = isAberto => ({ type: "SETCAIXA", isAberto });

export const removeAlerta = alerta => ({ type: "REMOVEALERTA", alerta });

export const setAlertas = alertas => ({ type: "SETALERTAS", alertas });

export const limparAlertas = alertas => ({ type: "LIMPARALERTAS", alertas });

export const setConnectionStatus = status => ({ type: status ? "ONLINE" : "OFFLINE" });

export const setTema = (tema, layout, isDark) => ({ type: tema, layout, isDark });

export const setIsInativo = () => ({ type: "SETINATIVO", isInativo: true });

export const setIsManutencao = () => ({ type: "SETMANUTENCAO", isManutencao: true });

export const setValidacoes = validacao => ({ type: "SETVALIDACAO", validacao });

export const setAtualizacao = atualizacao => ({ type: "SETATUALIZACAO", atualizacao });

export const setAuditoria = (type, auditoria) => ({ type, auditoria });

export const setDevConfig = (nome, valor, header) => ({ nome, valor, header, type: "SETDEVCONFIG" });

export const fetch = (versaoTemp) => _fetch(urlApi, false, versaoTemp);
export const fetchLocalAgent = () => _fetch(localAgentUrl, true);

export const _fetch = (urlExt, hideVersion, versaoTemp) => {
  return (dispatch, state) => {

    function formatUrl(url) {

      let urlFormated = url;
      let versao = versaoTemp || localStorage.getItem("versao");

      if (!isLocalhost && !hideVersion && !!versao)
        urlFormated = urlFormated.replace("/api", `/${versao}/api`);

      return urlFormated;
    }

    const tokenId = state().auth?.tokenId;
    const http = axios.create({
      baseURL: formatUrl(urlExt),
      transformRequest: [formatDates, ...axios.defaults.transformRequest]
    });

    function setDefaultHeaders(httpAux) {
      httpAux.defaults.headers.common["conexao"] = localStorage.getItem("conexao") || "";
      httpAux.defaults.headers.common["chavePdv"] = localStorage.getItem("chavePdv") || "";
    }

    state().devConfig.filter(x => !!x.header).forEach(x => http.defaults.headers.common[x.nome] = x.header);
    http.defaults.headers.common["Authorization"] = tokenId;

    setDefaultHeaders(http);

    http.interceptors.response.use(response => response,
      error => {
        const originalRequest = error.config;
        const response = error.response;

        function getOriginalRequest() {
          const url = originalRequest.url;
          const dados = originalRequest.data;

          var outsideResolve;
          var outsideReject;

          let promisse = new Promise(function (resolve, reject) {
            outsideResolve = resolve;
            outsideReject = reject;
          });

          return { promisse, resolve: outsideResolve, reject: outsideReject, url, dados: !!dados && JSON.parse(dados) };
        }

        if (response?.status === 401 && !originalRequest._retry) {
          originalRequest._retry = true;
          const httpAuth = axios;

          setDefaultHeaders(httpAuth);

          return httpAuth.post(`${formatUrl(urlApi)}/auth/refresh`, { tokenId: tokenId, refreshToken: state().auth?.refreshToken }).then(responseData => {
            const dados = responseData.data;
            if (!dados.sucesso) {
              return new Promise((resolve, reject) => {
                var count = 0;
                var interval = setInterval(() => {
                  const novoTk = state().auth?.tokenId;
                  if (!!novoTk && tokenId != novoTk) {
                    http.defaults.headers.common["Authorization"] = novoTk;
                    originalRequest.headers["Authorization"] = novoTk;
                    resolve(http(originalRequest));
                    clearInterval(interval);
                  }
                  else if (count == 10) {
                    dispatch({ type: "LOGOUT" });
                    reject();
                    clearInterval(interval);
                  }
                  count++;
                }, 1000);
              });
            }
            else {

              dispatch({
                type: "LOGIN",
                dados: {
                  tokenId: dados.tokenId,
                  refreshToken: dados.refreshToken,
                  user: dados.user,
                  userId: dados.userId,
                  empresa: dados.empresa
                }
              });

              http.defaults.headers.common["Authorization"] = dados.tokenId;
              originalRequest.headers["Authorization"] = dados.tokenId;
              return http(originalRequest);
            }
          });
        }
        else if (response?.status === 503) {
          const originalRequestFormated = getOriginalRequest();

          if (response.data?.manutencao)
            dispatch({ type: "SETMANUTENCAO", isManutencao: true });
          else if (response.data?.inativo)
            dispatch({ type: "SETINATIVO", isInativo: true });
          else if (response.data?.isValidacao && !state().validacao) {
            dispatch({ type: "SETVALIDACAO", validacao: { validacoes: response.data.validacoes, headers: response.data.headers, req: originalRequestFormated } });
            return originalRequestFormated.promisse;
          }
          else if (!!response.data?.isAuditoria && !state().auditoria) {
            dispatch({ type: "SETAUDITORIA", auditoria: { auditorias: response.data.auditorias, headers: response.data.headers, req: originalRequestFormated } });
            return originalRequestFormated.promisse;
          }
          else if (response.data == "acessorevogado")
            dispatch({ type: "SETCADASTRO", isCadastrado: false, acessoRevogado: true });
        }

        return Promise.reject(error);
      });

    return http;
  };
};

function formatDates(obj) {
  if (Array.isArray(obj))
    return obj.map(formatDates);
  else if (obj !== null && typeof obj === 'object') {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (dayjs.isDayjs(obj[key]))
          obj[key] = dayjs(obj[key]).format('YYYY-MM-DDTHH:mm:ss');
        else if (typeof obj[key] === 'object')
          formatDates(obj[key]);
      }
    }
  }

  return obj;
}